//
//  RESOURCES FOR ACCESSIBLE SLIDE-IN MENUS
//
//  @see https://codepen.io/impressivewebs/pen/qBbmMRJ
//  @see https://codepen.io/marcysutton/pen/JoQqVw
//  @see https://knowbility.org/blog/2020/accessible-slide-menus/
//  @see https://www.impressivewebs.com/accessible-keyboard-friendly-hamburger-menu-slide-out-navigation/
//

const nav = (() => {
  const isMediaLarge = window.matchMedia('(min-width: 1024px)');

  const overlay = document.getElementById('c-overlay');

  const menuButton = document.getElementById('c-menu-button');
  const navigation = document.getElementById('c-main-nav');
  const menu = document.getElementById('c-main-menu');
  const menuLinks = menu.querySelectorAll('a');
  const menuLinks0 = menu.querySelector('a');

  const searchButton = document.getElementById('c-search-button');
  const search = document.getElementById('c-search');
  const searchCloseButton = document.getElementById('c-search__close-button');
  const searchFormInput = document.getElementById('c-search-form__input');

  //
  //
  //
  function openMobileNav() {
    menu.classList.add('is-open');
    menuButton.setAttribute('aria-expanded', 'true');
    navigation.classList.add('is-open');
  }

  //
  //
  //
  function closeMobileNav() {
    menu.classList.remove('is-open');
    menuButton.removeAttribute('aria-expanded');
    navigation.classList.remove('is-open');
  }

  //
  //  NOTE. ESLint setup objects to for...of. Use forEach() instead.
  //
  function openSlideNav() {
    overlay.classList.add('is-open');

    menuLinks.forEach((menuLink) => {
      menuLink.removeAttribute('tabindex');
    });

    menu.classList.add('is-open');
    menuButton.setAttribute('aria-expanded', 'true');
    menuLinks0.focus();
    navigation.classList.add('is-open');
  }

  //
  //  NOTE. ESLint setup objects to for...of. Use forEach() instead.
  //
  function closeSlideNav() {
    overlay.classList.remove('is-open');

    menuLinks.forEach((menuLink) => {
      menuLink.setAttribute('tabindex', '-1');
    });

    menu.classList.remove('is-open');
    menuButton.removeAttribute('aria-expanded');
    navigation.classList.remove('is-open');
  }

  //
  //
  //
  function openSlideSearch() {
    overlay.classList.add('is-open');

    search.classList.add('is-open');
    searchButton.setAttribute('aria-expanded', 'true');

    searchFormInput.removeAttribute('tabindex');
    searchCloseButton.removeAttribute('tabindex');

    searchFormInput.focus();
  }

  //
  //
  //
  function closeSlideSearch() {
    overlay.classList.remove('is-open');

    search.classList.remove('is-open');
    searchButton.removeAttribute('aria-expanded');
    searchFormInput.setAttribute('tabindex', '-1');
    searchCloseButton.setAttribute('tabindex', '-1');
  }

  //
  //
  //
  function handleKeydown(event, elementToClose = null) {
    if (event.keyCode === 27) {
      if (elementToClose === navigation) {
        closeSlideNav();

        menuButton.focus();
      } else if (elementToClose === search) {
        closeSlideSearch();

        searchButton.focus();
      }
    }
  }

  //
  //
  //
  function handleDocumentClick(event) {
    const clickedElement = event.target;

    if (menu.classList.contains('is-open')) {
      if (
        clickedElement.closest('[id="c-menu-button"]') ||
        clickedElement.closest('[id="c-main-nav__close-button"') ||
        !clickedElement.closest('[id="c-main-nav"]') // Click was outside the main nav element
      ) {
        closeSlideNav();
      }
    } else if (search.classList.contains('is-open')) {
      if (
        clickedElement.closest('[id="c-search-button"]') ||
        clickedElement.closest('[id="c-search__close-button"') ||
        !clickedElement.closest('[id="c-search"]') // Click was outside the search element
      ) {
        closeSlideSearch();
      }
    } else if (clickedElement.closest('[id="c-menu-button"]')) {
      openSlideNav();
    } else if (clickedElement.closest('[id="c-search-button"]')) {
      openSlideSearch();
    }
  }

  //
  //
  //
  function handleMenuButtonClick() {
    if (menu.classList.contains('is-open')) {
      closeMobileNav();
    } else {
      openMobileNav();
    }
  }

  //
  //
  //
  function mediaQueryTest(response) {
    if (response.matches) {
      //
      //  Screen is WIDER than 1025px
      //
      menuButton.removeEventListener('click', handleMenuButtonClick);

      document.addEventListener('click', handleDocumentClick);

      document.addEventListener('keydown', (event) => {
        if (menu.classList.contains('is-open')) {
          handleKeydown(event, navigation);
        } else if (search.classList.contains('is-open')) {
          handleKeydown(event, search);
        }
      });
    } else {
      //
      //  Screen is NARROWER than 1025px
      //
      document.removeEventListener('click', handleDocumentClick);

      menuButton.addEventListener('click', handleMenuButtonClick);
    }
  }

  //
  //  Safari before version 14 does not support `addEventListener` for `window.matchMedia`.
  //  Have to use the deprecated `addListener` for the time being.
  //
  // isMediaLarge.addEventListener('change', mediaQueryTest);
  isMediaLarge.addListener(mediaQueryTest);

  mediaQueryTest(isMediaLarge);
})();

export default nav;
